import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings, toggleSearch } from '../../common/services/selectors';
import Pager from '../../common/components/_Pager';
import SearchItem from './GenericSearchItem';
import SearchFilter from './GenericSearchFilter';


function SearchResults({ entries, search, filters, settings, store }) { 
    const { items = [] } = entries || {};
	return (
        <div> 
            <div className="row">
                <div className="large-12 column">
                    <h1 className="search-title">Search results</h1>
                    { search.term && <p className="search-keyword">{entries.totalCount} result(s) found for <strong>{ search.term && search.term}</strong></p>}
                </div>
            </div>
            <div className="row">
                <div className="column large-3 large-push-9">
                    <SearchFilter filters={filters} search={search} store={store}/>
                </div>
                <div className="column large-8 large-pull-3">
                    <div className="row">
                        <div className="large-12 column">
                            {entries.totalCount === 0 && <p>Nothing Found</p>}
                            {entries.totalCount > 0 && 
                                items.map((entry, index) => <SearchItem key={entry.sys.id} entry={entry} index={index} settings={settings} />) }
                        </div>
                    </div>
                    {entries.totalCount > 10 && <Pager entries={entries} search={search} settings={settings} />}
                </div>
            </div>
        </div>
	);
}


SearchResults.propTypes = {
    entries: PropTypes.object,
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
    store: PropTypes.object
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state), toggle: toggleSearch(state) });

export default connect(mapStateToProps)(SearchResults);